import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ChatConfigPayload } from './chat.types';

export const DEFAULT_MESSAGE_MAX_CHARACTERS = 1000;

export class ChatConfigService {
  private _http = inject(HttpClient);
  private _config$?: Observable<ChatConfigPayload>;

  getConfig(): Observable<ChatConfigPayload> {
    this._config$ ??= this._http.get<ChatConfigPayload>(`${environment.apiUrl}/chat/config`).pipe(
      map((config) => ({
        initialMessage:
          typeof config.initialMessage === 'string'
            ? config.initialMessage
            : environment.welcomeMessage,
        messageMaxCharacters: this._getMessageMaxCharacters(config.messageMaxCharacters),
      })),
      catchError(() =>
        of({
          initialMessage: environment.welcomeMessage,
          messageMaxCharacters: DEFAULT_MESSAGE_MAX_CHARACTERS,
        }),
      ),
      shareReplay({ bufferSize: 1, refCount: false }),
    );

    return this._config$;
  }

  private _getMessageMaxCharacters(value: number): number {
    return Number.isInteger(value) && value > 0 ? value : DEFAULT_MESSAGE_MAX_CHARACTERS;
  }
}
